import { useState } from 'react';
import phoneImage from '../media/phone.png';
import arrowIcon from '../media/flecha.png';

const capabilities = [
  {
    id: 'soporte',
    title: 'Soporte remoto',
    description:
      'Imagina que cada vez que te surge una nueva duda, incidencia o problema informático tienes a tu disposición un técnico especializado que te atiende al momento y te aporta soluciones rápidas y eficaces a través de internet, sin necesidad de estar físicamente delante de tu computadora. No suena nada mal, ¿verdad?',
  },
  {
    id: 'alianzas',
    title: 'Alianzas robustas',
    description:
      'Trabajamos de la mano con organizaciones de clase mundial para entregarte la mejor combinación de tecnologías y servicios. Somos partners certificados de los fabricantes líderes en la industria de TI y trabajamos con ellos para acercarte a nuevas tecnologías.',
  },
  {
    id: 'software',
    title: 'Software personalizado',
    description:
      'Manufactura y producción, finanzas y contabilidad, recursos humanos, ventas y marketing, y más.',
  },
];

/**
 * Sección "¿Qué hacemos?" del home: un acordeón con las tres capacidades
 * principales de la empresa.
 *
 * Cada cabecera es un <button> y no un <a> sin href. Así el bloque se puede
 * recorrer con el tabulador y abrir con Enter o barra espaciadora, y los
 * lectores de pantalla anuncian si el panel está abierto gracias a
 * aria-expanded.
 */
const WhatWeDo = () => {
  const [openCapabilityId, setOpenCapabilityId] = useState(capabilities[0].id);

  return (
    <section className="aboutSection">
      <div className="aboutSectionText">
        <h3>¿Qué hacemos?</h3>
        <p className="textBold">En Axioma Network</p>

        <div>
          {capabilities.map(({ id, title, description }) => {
            const isOpen = openCapabilityId === id;

            return (
              <div className="aboutServiceItem" key={id}>
                <div>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={`capability-${id}`}
                    onClick={() => setOpenCapabilityId(id)}
                  >
                    <h4>{title}</h4>
                    <span>
                      <img className={isOpen ? 'isRotated' : ''} src={arrowIcon} alt="" />
                    </span>
                  </button>
                </div>
                <p
                  id={`capability-${id}`}
                  className={`textContent ${isOpen ? 'isVisible' : 'isHidden'}`}
                >
                  {description}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="aboutSectionImg">
        <img src={phoneImage} alt="Aplicación móvil desarrollada por Axioma Network" />
      </div>
    </section>
  );
};

export default WhatWeDo;
